module.exports = function getResource(label, vars = []) {
    let resources = {
        subscriptions: 'Abonnements',
        sorrySubscriptionsUnavailable: 'Nous sommes désolés, les services d’abonnement ne sont pas disponibles au Canada à cette heure.'
    };

    return resources[label];
};
